import { render, staticRenderFns } from "./ProductSelectTitle.vue?vue&type=template&id=542b7137&scoped=true"
import script from "./ProductSelectTitle.vue?vue&type=script&lang=js"
export * from "./ProductSelectTitle.vue?vue&type=script&lang=js"
import style0 from "./ProductSelectTitle.vue?vue&type=style&index=0&id=542b7137&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542b7137",
  null
  
)

export default component.exports